import { withTranslator } from "app/decorators";
import ProductListItem from "./ProductListItem";

export default withTranslator(ProductListItem);



// WEBPACK FOOTER //
// ./src/app/components/ProductListItem/ProductListItemContainer.js